var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout-card", {
    staticClass: "card-order_corp",
    attrs: {
      error: _vm.error,
      loading: _vm.loading,
      type: _vm.settings.context,
      isCustomizable: _vm.settings.isCustomizable
    },
    on: {
      "edit-card": _vm.toggleSettingsForm,
      "hide-card": function($event) {
        return _vm.$emit("hide-card", _vm.type)
      },
      "refresh-card": function($event) {
        return _vm.fetchCard(_vm.type, {}, true)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [_vm._v("\n        " + _vm._s(_vm.name) + "\n    ")]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("template-kpi-card", {
              attrs: { data: { stats: _vm.cardData, labels: _vm.labels } }
            }),
            _vm._v(" "),
            _c(
              "portal",
              { attrs: { to: "dashboardSettingsForm" } },
              [
                _vm.showSettingsForm
                  ? _c("card-setting-overlay", {
                      attrs: {
                        formName: _vm.settingsFormName,
                        cardCustomSettings: _vm.customSettings,
                        cardName: _vm.type
                      },
                      on: {
                        fetched: _vm.fetchCard,
                        "close-form": _vm.toggleSettingsForm,
                        "custom-settings-saved": function($event) {
                          return _vm.fetchCard(_vm.type, {}, true)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("fiscal-year-footer", {
              attrs: { fiscalYearTimestamp: _vm.fiscalYear }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }